import { makeStyles } from 'tss-react/mui';
import {PillStyleProps} from './Pill';

export const usePillStyles = makeStyles<PillStyleProps>()(
  (theme, props) => ({
    pillStyle: {
      // appearance
      borderRadius: '8px',
      height: '15px',
      width: props.pillWidth ?? '68px',

      border: 'none',
      margin: 0,
      backgroundColor: props.pillColor,
      padding: '3px 7px 0px 7px',
      textAlign: 'center',

      // text
      textTransform: 'uppercase',
      fontWeight: 'normal',
      fontSize: '0.6rem',
      color: 'white',

      // cursor: 'pointer',
      // overwrite MUI's hover
      '&:hover': {
        backgroundColor: props.pillColor,
      },
    },
    fontFamilyStyle: {
      ...theme.typography,
    } as any,
  })
);
